import React, { useState, useEffect } from 'react'

import { useAppSelector } from 'redux/hooks'

import MultiSelectDropdown from 'components/formElements/MultiSelectDropdown'

const options = [
  { value: 'Artifact', label: 'Artifact', searchString: 'Artifact' },
  { value: 'Conspiracy', label: 'Conspiracy', searchString: 'Conspiracy' },
  { value: 'Creature', label: 'Creature', searchString: 'Creature' },
  { value: 'Enchantment', label: 'Enchantment', searchString: 'Enchantment' },
  { value: 'Instant', label: 'Instant', searchString: 'Instant' },
  { value: 'Land', label: 'Land', searchString: 'Land' },
  { value: 'Phenomenon', label: 'Phenomenon', searchString: 'Phenomenon' },
  { value: 'Plane', label: 'Plane', searchString: 'Plane' },
  { value: 'Planeswalker', label: 'Planeswalker', searchString: 'Planeswalker' },
  { value: 'Scheme', label: 'Scheme', searchString: 'Scheme' },
  { value: 'Sorcery', label: 'Sorcery', searchString: 'Sorcery' },
  { value: 'Vanguard', label: 'Vanguard', searchString: 'Vanguard' },
  { value: 'Kindred', label: 'Kindred', searchString: 'Kindred' },
  { value: 'Battle', label: 'Battle', searchString: 'Battle' },
]

type Props = {
  onChange: (values: string[]) => void
  value?: string[]
}

const TypeDropdown = ({ value, onChange }: Props) => {
  const isMobile = useAppSelector(state => state.active.isMobile)

  const [selectedOptions, setSelectedOptions] = useState(value ?? new Array<string>())

  // Used to reset the form
  useEffect(() => {
    if (!value || !value?.length) setSelectedOptions([])
  }, [value])

  const handleChange = (selectedOptions: string[]) => {
    setSelectedOptions(selectedOptions)
    onChange(selectedOptions)
  }

  return (
    <MultiSelectDropdown
      searchable={!isMobile}
      placeholder="Type (eg: Creature)"
      onChange={handleChange}
      options={options}
      value={selectedOptions}
    />
  )
}

export default TypeDropdown
